"use strict";
var ApiSmartQuoteResponse = (function () {
    function ApiSmartQuoteResponse() {
    }
    return ApiSmartQuoteResponse;
}());
exports.ApiSmartQuoteResponse = ApiSmartQuoteResponse;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/api-smart-quote-response.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/api-smart-quote-response.model.js